import { Card } from "./layoutComponents/Card/Card";
import { CardBody } from "./layoutComponents/CardBody/CardBody";
import { CardAside } from "./layoutComponents/CardAside/CardAside";
import { CardFooter } from "./layoutComponents/CardFooter/CardFooter";
import { CardHeader } from "./layoutComponents/CardHeader/CardHeader";
import { CardTitle } from "./compositionComponents/CardTitle/CardTitle";
import { CardImage } from "./compositionComponents/CardImage/CardImage";
import { CardTagsListing } from "./compositionComponents/CardTagsListing/CardTagsListing";
import { CardTime } from "./compositionComponents/CardTime/CardTime";
import { CardListing } from "./compositionComponents/CardListing/CardListing";
import { CardSpaceBetween } from "./compositionComponents/CardSpaceBetween/CardSpaceBetween";

// Components for card layout
Card.Body = CardBody;
Card.Aside = CardAside;
Card.Footer = CardFooter;
Card.Header = CardHeader;

// Component for card composition
Card.Title = CardTitle;
Card.Time = CardTime;
Card.Image = CardImage;
Card.TagsListing = CardTagsListing;
Card.Listing = CardListing;
Card.SpaceBetween = CardSpaceBetween;
export { Card };